var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgForklift = function SvgForklift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "forklift_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 41.2 33.2"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".forklift_svg__st0{fill:#cc9b00}.forklift_svg__st1{fill:#fcc000}.forklift_svg__st2{fill:#fcce3a}.forklift_svg__st3{fill:#011c2b}.forklift_svg__st4{fill:#025074}.forklift_svg__st5{fill:#c2c2c2}.forklift_svg__st6{fill:#b68b00}.forklift_svg__st7{fill:#dea900}.forklift_svg__st8{fill:#a27b00}.forklift_svg__st9{fill:#379780}.forklift_svg__st10{fill:#008f7f}.forklift_svg__st11{fill:#00b39f}.forklift_svg__st12{fill:#c2b6a1}.forklift_svg__st13{fill:#fff}.forklift_svg__st14{fill:#d3b8a6}.forklift_svg__st15{fill:#dcceb6}.forklift_svg__st16{fill:#edceba}.forklift_svg__st17{fill:#f0e7d8}.forklift_svg__st18{fill:#02374f}.forklift_svg__st19{fill:#491a09}.forklift_svg__st20{fill:#037ab0}.forklift_svg__st21{fill:#025e87}.forklift_svg__st22{fill:#025375}.forklift_svg__st23{fill:#00473d}.forklift_svg__st24{fill:#006458}.forklift_svg__st25{fill:#00d3a9}.forklift_svg__st26{fill:#6f3b21}.forklift_svg__st27{fill:#5c311b}.forklift_svg__st28{fill:#99522d}.forklift_svg__st29{fill:#854727}.forklift_svg__st30{fill:#6f3c21}.forklift_svg__st31{fill:#b76236}.forklift_svg__st32{fill:#e0b477}.forklift_svg__st33{fill:#bb884f}.forklift_svg__st34{fill:#efcd90}.forklift_svg__st35{fill:#f7ecea}.forklift_svg__st36{fill:#c2ab9d}.forklift_svg__st37{fill:#5c4123}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2 24.9v1.2l10.7 5.7v-1.2z",
    className: "forklift_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9 30.6v1.2l1.2-.7v-1.2z",
    className: "forklift_svg__st1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m14.2 24.9 10.7 5.7 1.2-.7-10.7-5.7z",
    className: "forklift_svg__st2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m26.1 17.4.1 1.2 10.7 5.7-.1-1.2z",
    className: "forklift_svg__st0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m36.8 23.1.1 1.2 1.1-.8v-1.2z",
    className: "forklift_svg__st1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m26.1 17.4 10.7 5.7 1.2-.8-10.7-5.7z",
    className: "forklift_svg__st2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 18.7c.3-.2.8-.2 1.4 0 .1 0 .1.1.2.1.8.4 1.5 1.3 1.9 2.2.2.5.4 1 .4 1.5 0 .7-.2 1.2-.6 1.4l-1.4.9c.4-.2.6-.7.6-1.4 0-.5-.2-1-.4-1.5-.4-.9-1.1-1.7-1.9-2.2-.1 0-.1-.1-.2-.1-.5-.2-1-.2-1.4 0z",
    className: "forklift_svg__st3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7 19.7c-1.2-.6-2.2-.1-2.1 1.3 0 1.4 1.1 3 2.3 3.7 1.2.6 2.2.1 2.1-1.3s-1.1-3.1-2.3-3.7",
    className: "forklift_svg__st4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7 21c-.6-.3-1 0-1 .6s.5 1.4 1.1 1.7 1 0 1-.6-.5-1.4-1.1-1.7",
    className: "forklift_svg__st5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6 14.9c.3-.2.8-.2 1.4 0 .1 0 .1.1.2.1.8.4 1.5 1.3 1.9 2.2.2.5.4 1 .4 1.5 0 .7-.2 1.2-.6 1.4l-1.4.9c.4-.2.6-.7.6-1.4 0-.5-.2-1-.4-1.5-.4-.9-1.1-1.7-1.9-2.2-.1 0-.1-.1-.2-.1-.5-.2-1-.2-1.4 0z",
    className: "forklift_svg__st3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7 15.9c-1.2-.6-2.2-.1-2.1 1.3 0 1.4 1.1 3 2.3 3.7 1.2.6 2.2.1 2.1-1.3s-1.1-3-2.3-3.7",
    className: "forklift_svg__st4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7 17.2c-.6-.3-1 0-1 .6s.5 1.4 1.1 1.7 1 0 1-.6-.5-1.4-1.1-1.7",
    className: "forklift_svg__st5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 10.4 27.2 16v.6l-10.3-5.5z",
    className: "forklift_svg__st6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2 16v.6l.8-.5v-.6z",
    className: "forklift_svg__st7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m16.8 9.5 11.2 6-.8.5-10.4-5.6z",
    className: "forklift_svg__st8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m0 13.5.1 4.1 12.3 6.5-.1-4z",
    className: "forklift_svg__st9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m12.3 20.1.1 4 11.9-7.4-.1-4.1z",
    className: "forklift_svg__st10"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m0 13.5 12.3 6.6 11.9-7.5L11.8 6z",
    className: "forklift_svg__st11"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2 18.1v.6l10.7 5.8v-.7z",
    className: "forklift_svg__st6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9 23.8v.7l.8-.5v-.7z",
    className: "forklift_svg__st7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m4.2 18.1 10.7 5.7.8-.5L5 17.6z",
    className: "forklift_svg__st8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m15.5 20.2 13.1-8.3-1.4-.8L14 19.4z",
    className: "forklift_svg__st2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m15.6 25.7 13.2-8.3-.2-5.5-13.1 8.3z",
    className: "forklift_svg__st1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m14 19.4.2 5.5 1.4.8-.1-5.5z",
    className: "forklift_svg__st0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m13.1 12.9-2.4-1.2v1.7l2.4 1.3z",
    className: "forklift_svg__st12"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m15.3 11.5-2.4-1.3-2.2 1.5 2.4 1.2z",
    className: "forklift_svg__st13"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1 12.9v1.8l2.3-1.4-.1-1.8z",
    className: "forklift_svg__st14"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m13.1 13.9-3.3-1.8v.3l3.3 1.7z",
    className: "forklift_svg__st15"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m16.2 11.9-3.3-1.8-3.1 2 3.3 1.8z",
    className: "forklift_svg__st13"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1 13.9v.2l3.1-1.9v-.3z",
    className: "forklift_svg__st16"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m9.9 7.8-.3-.2.2 4.5.2.1z",
    className: "forklift_svg__st15"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m13 5.8-.2-.1-3.2 1.9.3.2z",
    className: "forklift_svg__st13"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m9.9 7.8.1 4.4 3.2-1.9-.2-4.5z",
    className: "forklift_svg__st17"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m15.9 12-.1-.1-.3.6h.1c.1-.1.2-.3.3-.5m-.4.6c-.2.1-.2.2-.3.2h.1zm-.1.2-.3.2h.2c0-.1 0-.1.1-.2m-.2.2H15l-.1.1zc-.1 0 0 0 0 0m.7-1.4-.1-.1zm-.8 1.5h-.2zq-.15 0 0 0m-.1 0h-.2c-.2.1-.4.2-.5.2h.2c.2 0 .3 0 .5-.2M15.8 11.3l-.2-.1c.1.1.1.1.2.1.1.1 0 0 0 0M15.9 11.4l-.1-.1zm0 .1-.1-.1zq0 .15 0 0",
    className: "forklift_svg__st18"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m15.9 11.6-1.8 1.2h.2z",
    className: "forklift_svg__st18"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3 12.8h-.2z",
    className: "forklift_svg__st19"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m16 11-.2-.1c-.1-.1-.4-.1-.7.1l.2.1c.3-.1.5-.2.7-.1m-.7.2-.2-.1H15z",
    className: "forklift_svg__st20"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m15.3 11.2-.2-.1c-.1.1-.2.1-.2.2l.2.1c0-.1.1-.1.2-.2m-.3.2-.2-.1-.3.3.2.1q.3-.15.3-.3",
    className: "forklift_svg__st20"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m14.8 11.7-.2-.1c-.1.1-.2.3-.3.4l.2.1c.1-.2.2-.3.3-.4",
    className: "forklift_svg__st20"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m14.5 12-.2-.1c-.2.3-.4.7-.4 1h.2c.1-.2.2-.5.4-.9m-.4 1h-.2v.3h.2z",
    className: "forklift_svg__st20"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1 13.2h-.2c0 .1 0 .1.1.2h.2c-.1 0-.1-.1-.1-.2m.1.2H14s0 .1.2 0l.1.1c-.1 0-.1-.1-.1-.1m.1.1h-.2z",
    className: "forklift_svg__st20"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1 11.6c-.1.5-.6 1.2-1.1 1.6s-.9.4-.9-.1c0-.6.5-1.5 1.2-2 .6-.3.9-.1.8.5m-.9-.1c-.4.3-.8.9-.9 1.3l1.6-1.2c0-.3-.2-.4-.7-.1m-.1 1.6c.3-.3.7-.7.8-1.1l-1.5 1.2c0 .2.3.2.7-.1",
    className: "forklift_svg__st21"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m15.1 12.4.3-.2zl-.2.1z",
    className: "forklift_svg__st21"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m16.8 16 .3-.2-1.7-3.6-.3.2z",
    className: "forklift_svg__st18"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m15.1 12.4-.1.2 1.6 3.5.2-.1z",
    className: "forklift_svg__st22"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6 12.7 13.7 18l-3.4-9.4-6.9-3.9zm.7-.3-.2-6.3 6.2 3.3 3.1 7.9z",
    className: "forklift_svg__st23"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m3.2 12.9 10.7 5.7-3.5-9.7L3 5zm.6-.4-.2-6.3 6.2 3.3 3.1 7.9z",
    className: "forklift_svg__st24"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m10.2 9.6 3.7 8.6 7.4-4.6-3.3-9zm.5-.3L17.5 5l3.1 8.1-6.6 4.1z",
    className: "forklift_svg__st24"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m10.4 8.9 3.5 9.7 7.8-4.9L18.2 4zm.7.3 6.8-4.3 3.2 8.5-6.8 4.3z",
    className: "forklift_svg__st9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 8.9 18.2 4l-7.4-4-7.9 4.9z",
    className: "forklift_svg__st25"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1 31.9v.7l1 .6v-.7z",
    className: "forklift_svg__st26"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1 32.5v.7L41.2 20l-.1-.7z",
    className: "forklift_svg__st27"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m19.1 31.9 1 .6 21-13.2-1-.5z",
    className: "forklift_svg__st28"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m14.1 28.5.1.7 1 .6v-.7z",
    className: "forklift_svg__st26"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 29.1v.7l21-13.2v-.7z",
    className: "forklift_svg__st27"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m14.1 28.5 1.1.6 21-13.2-1-.5z",
    className: "forklift_svg__st28"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7 23v.6l-1.6 1V24z",
    className: "forklift_svg__st29"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1 24v.6l-11.2-6V18z",
    className: "forklift_svg__st30"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m40.7 23-1.6 1-11.2-6 1.6-1z",
    className: "forklift_svg__st31"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3 26.3v.6l-1.6 1v-.6z",
    className: "forklift_svg__st29"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7 27.3v.6L22.5 22v-.6z",
    className: "forklift_svg__st30"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m35.3 26.3-1.6 1-11.2-5.9 1.6-1z",
    className: "forklift_svg__st31"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9 30.4v.6l-1.6 1.1v-.6z",
    className: "forklift_svg__st29"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3 31.5v.6l-11.2-6v-.6z",
    className: "forklift_svg__st30"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "m28.9 30.4-1.6 1.1-11.2-6 1.6-1z",
    className: "forklift_svg__st31"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m24.3 18.3.2 4.6 5.5 3-.2-4.7z",
    className: "forklift_svg__st32"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "m29.8 21.2.2 4.7 7.6-4.8-.2-4.7z",
    className: "forklift_svg__st33"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m24.3 18.3 5.5 2.9 7.6-4.8-5.4-2.9z",
    className: "forklift_svg__st34"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "m34.1 14.6 1.1.6-7.6 4.8-1.2-.6z",
    className: "forklift_svg__st35"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "m27.6 20-1.2-.6.1 1.1 1.1.6z",
    className: "forklift_svg__st36"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "m25.1 22.7.8.5v-.1zm.1 0 .1-.6.1.1-.2-.3-.1.1.1.1zm.4.2.1-.5h.1l-.1-.3-.2.2h.1z",
    className: "forklift_svg__st37"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "m25.9 23.4-.8-.4c-.2-.1-.3-.3-.3-.4v-.8c0-.2.1-.2.3-.1l.8.4c.2.1.3.3.3.4v.8c0 .1-.1.2-.3.1m-.9-1.8c-.1-.1-.2 0-.2.1v.8c0 .1.1.3.2.4l.8.4c.1.1.2 0 .2-.1v-.8c0-.1-.1-.3-.2-.4zM27.6 23.6s-.1-.1-.2-.1c-.1-.1-.2-.1-.2-.1l-.1-.1v.6c0 .1-.1.1-.1 0-.1 0-.1-.1-.1-.2 0 0 0 .1.1.1h.1v-.5c-.1 0-.1-.1-.1 0 0 0-.1-.1-.2-.1-.1-.1-.2-.1-.2-.1 0-.2.2-.3.5-.2.3.2.5.5.5.7",
    className: "forklift_svg__st37"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "m27.6 24.3-.8-.4c-.2-.1-.3-.3-.3-.4v-.8c0-.2.1-.2.3-.1l.8.4c.2.1.3.3.3.4v.8c-.1.1-.2.2-.3.1m-.9-1.8c-.1-.1-.2 0-.2.1v.8c0 .1.1.3.2.4l.8.4c.1.1.2 0 .2-.1v-.8c0-.1-.1-.3-.2-.4zM29 24.2c0 .1-.1.2-.2.1v.4l.1.1v.1l-.3-.2v-.1l.1.1v-.4c-.1-.1-.2-.2-.2-.4v-.3l.4.2z",
    className: "forklift_svg__st37"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "m29.2 25.2-.8-.4c-.2-.1-.3-.3-.3-.4v-.8c0-.2.1-.2.3-.1l.8.4c.2.1.3.3.3.4v.8c0 .1-.1.1-.3.1m-.9-1.8c-.1-.1-.2 0-.2.1v.8c0 .1.1.3.2.4l.8.4c.1.1.2 0 .2-.1v-.8c0-.1-.1-.3-.2-.4z",
    className: "forklift_svg__st37"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "m14.6 24.3.1 4.7 5.5 2.9-.2-4.7z",
    className: "forklift_svg__st32"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "m20 27.2.2 4.7 7.6-4.8-.2-4.6z",
    className: "forklift_svg__st33"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "m14.6 24.3 5.4 2.9 7.6-4.7-5.4-2.9z",
    className: "forklift_svg__st34"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "m24.3 20.7 1.1.6-7.6 4.8-1.1-.6z",
    className: "forklift_svg__st35"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "m17.8 26.1-1.1-.6v1.1l1.1.6z",
    className: "forklift_svg__st36"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "m15.3 28.7.8.6v-.1zm.1 0 .1.1v-.6l.1.1-.1-.4-.2.2.1.1zm.5.3v-.6l.1.1-.1-.3-.1.1v.1z",
    className: "forklift_svg__st37"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "m16.1 29.5-.8-.4c-.2-.1-.3-.3-.3-.4v-.8c0-.2.1-.2.3-.1l.8.4c.2.1.3.3.3.4v.8c0 .1-.1.1-.3.1m-.8-1.8c-.1-.1-.2 0-.2.1v.8c0 .1.1.3.2.4l.8.4c.1.1.2 0 .2-.1v-.8c0-.1-.1-.3-.2-.4zM17.9 29.7s0-.1 0 0c0 0-.1-.1-.2-.1-.1-.1-.2-.1-.2-.1l-.1-.1v.6c0 .1-.1.1-.1 0-.1 0-.1-.1-.1-.2 0 0 0 .1.1.1h.1v-.5c-.1 0-.1-.1-.1 0 0 0-.1-.1-.2-.1-.1-.1-.2-.1-.2-.1 0-.2.2-.3.5-.2.2.1.5.4.5.7",
    className: "forklift_svg__st37"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "m17.8 30.3-.8-.4c-.2-.1-.3-.3-.3-.4v-.8c0-.2.1-.2.3-.1l.8.4c.2.1.3.3.3.4v.8c0 .2-.2.2-.3.1m-.9-1.7c-.1-.1-.2 0-.2.1v.8c0 .1.1.3.2.4l.8.4c.1.1.2 0 .2-.1v-.8c0-.1-.1-.3-.2-.4zM19.2 30.2c0 .1-.1.2-.2.1v.4l.1.1v.1l-.3-.2v-.1l.1.1v-.4c-.1-.1-.2-.2-.2-.4v-.3l.4.2z",
    className: "forklift_svg__st37"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "m19.4 31.2-.8-.4c-.2-.1-.3-.3-.3-.4v-.8c0-.2.1-.2.3-.1l.8.4c.2.1.3.3.3.4v.8c0 .1-.1.2-.3.1m-.9-1.8c-.1-.1-.2 0-.2.1v.8c0 .1.1.3.2.4l.8.4c.1.1.2 0 .2-.1v-.8c0-.1-.1-.3-.2-.4z",
    className: "forklift_svg__st37"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "m17.5 17.3.2 4.7 5.4 2.9-.2-4.7z",
    className: "forklift_svg__st32"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "m22.9 20.2.2 4.7 7.6-4.8-.1-4.6z",
    className: "forklift_svg__st33"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "m17.5 17.3 5.4 2.9 7.7-4.7-5.5-2.9z",
    className: "forklift_svg__st34"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "m27.2 13.7 1.2.6-7.7 4.8-1.1-.6z",
    className: "forklift_svg__st35"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "m20.7 19.1-1.1-.6v1.1l1.2.6z",
    className: "forklift_svg__st36"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "m18.2 21.7.9.6v-.1zm.2 0v-.5h.1l-.1-.3-.1.2zm.4.3.1-.6.1.1-.2-.3-.1.1.1.1z",
    className: "forklift_svg__st37"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "m19.1 22.5-.8-.4c-.2-.1-.3-.3-.3-.4v-.8c0-.2.1-.2.3-.1l.8.4c.2.1.3.3.3.4v.8c-.1.1-.2.1-.3.1m-.9-1.8c-.1-.1-.2 0-.2.1v.8c0 .1.1.3.2.4l.8.4c.1.1.2 0 .2-.1v-.8c0-.1-.1-.3-.2-.4zM20.8 22.6s-.1-.1-.2-.1c-.1-.1-.2-.1-.2-.1l-.1-.1v.6c0 .1-.1.1-.1 0-.1 0-.1-.1-.1-.2 0 0 0 .1.1.1h.1v-.5c-.1 0-.1-.1-.1 0 0 0-.1-.1-.2-.1-.1-.1-.2-.1-.2-.1 0-.2.2-.3.5-.2.3.2.5.5.5.7 0 0 0 .1 0 0",
    className: "forklift_svg__st37"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "m20.7 23.3-.8-.4c-.2-.1-.3-.3-.3-.4v-.8c0-.2.1-.2.3-.1l.8.4c.2.1.3.3.3.4v.8c0 .2-.1.2-.3.1m-.9-1.7c-.1-.1-.2 0-.2.1v.8c0 .1.1.3.2.4l.8.4c.1.1.2 0 .2-.1v-.8c0-.1-.1-.3-.2-.4zM22.1 23.2c0 .1-.1.2-.2.1v.4l.1.1v.1l-.3-.2v-.1l.1.1v-.4c-.1-.1-.2-.2-.2-.4v-.3l.4.2z",
    className: "forklift_svg__st37"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "m22.3 24.2-.8-.4c-.2-.1-.3-.3-.3-.4v-.8c0-.2.1-.2.3-.1l.8.4c.2.1.3.3.3.4v.8c0 .1-.1.2-.3.1m-.8-1.8c-.1-.1-.2 0-.2.1v.8c0 .1.1.3.2.4l.8.4c.1.1.2 0 .2-.1v-.8c0-.1-.1-.3-.2-.4z",
    className: "forklift_svg__st37"
  })));
};
export { SvgForklift as ReactComponent };
export default __webpack_public_path__ + "static/forklift.81115a37.svg";